<axis-admin-shell
  [secondarySidebarOverlay]="true"
  [collapseSecondaryBelowWidth]="1400"
></axis-admin-shell>
